import { InjectionToken } from '@angular/core';
import { SiteContextConfig } from '@spartacus/core';

export const SITE_CONTEXT_CONFIG = new InjectionToken<SiteContextConfig>('siteContextConfig');
